module.exports = __webpack_public_path__ + "img/twitter-brands.96a7904.svg";